import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Typography,
    IconButton,
    CircularProgress,
    Grid,
    FormControl,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

// Project Imports
import { colors } from "../../Styles/GlobalStyles/Variables";
import { GreenButton, GreyFilledButton } from "../Button/CustomButton";
import Iconify from "../Dashboard/Iconify";
import { AwardIcon } from "../MuiDataTableTheme/MuiDataTableTheme";


const theme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: "Public Sans, sans-serif",
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                scrollPaper: {
                    alignItems: "flex-start",
                    fontFamily: "Public Sans, sans-serif",
                },
            },
        },
    },
});

const AlertDialog = ({
    alertDialog,
    setAlertDialog,
}) => {
    return (
        <ThemeProvider theme={theme}>
            <Dialog
                open={alertDialog.isOpen}
                sx={{
                    backdropFilter: "blur(4px)",
                }}
                PaperProps={{
                    style: {
                        padding: "15px 10px",
                        borderRadius: "12px",
                        width: alertDialog.width ?? "350px",
                  
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        fontFamily: "Public Sans, sans-serif",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection:"column",
                        gap:2
                    }}
                >
                    <IconButton
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        sx={{ bgcolor: !alertDialog?.isLoad? alertDialog?.isLoading?"#E1EDE8": "#FFEBEB" :"#E1EDE8", color: "#E53535", cursor: "text" }}
                    >
                        {alertDialog?.isLoading?
                        <CircularProgress size={23} sx={{color:"#016c34"}}/>:
                        <AwardIcon icon={"fluent:key-reset-24-filled"} sx={{fontSize:"30px", color:alertDialog?.isLoad?"#016c34":"red"}}/>}
                    </IconButton>
                    <Typography textAlign={"center"} variant="h6" fontWeight={"700"}>{alertDialog?.header}</Typography>
                </DialogTitle>
                {/* <Divider /> */}

                <DialogContent
                    sx={{ fontSize: "14px", textAlign: "center", padding: "0px", display:"flex", justifyContent:"center" }}
                >
                    <Typography
                        sx={{
                            color: "#23262F",
                            fontWeight: 400,
                            fontSize: "14px",
                            mb: "20px",
                            width:"300px"
                        }}
                        variant="h6"
                    >
                        {alertDialog.title}
                    </Typography>

                    {alertDialog.note ? (
                        <Typography>This action cannot be undone</Typography>
                    ) : (
                        ""
                    )}
                </DialogContent>

                <DialogActions>
                    <GreyFilledButton
                        color="secondary"
                        sx={{ fontFamily: "Public Sans, sans-serif", padding: "10px 25px" }}
                        onClick={() =>
                            setAlertDialog({ ...alertDialog, isOpen: false })
                        }
                    >
                        Cancel
                    </GreyFilledButton>
                    {alertDialog?.isSuccessful?"":
                    <GreenButton
                        sx={{ fontFamily: "Public Sans, sans-serif", padding: "10px 25px" }}
                        color="primary"
                        onClick={alertDialog.onConfirm}
                    >
                        {alertDialog?.isLoading ? (
                            <CircularProgress size={24} sx={{color:"#016c34"}}/>
                        ) : (
                            "I confirm"
                        )}
                    </GreenButton>}
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
};

export default AlertDialog;


